import Img from "~/components/common/img";
import MainButton from "~/components/common/mainButton";
import AsperandIcon from "~/components/icons/asperand.icon";
import BookingIcon from "~/components/icons/booking.icon";
import LocationIcon from "~/components/icons/location.icon";
import PhoneIcon from "~/components/icons/phone.icon";
import { PartnershipType } from "~/types/partnership/partnership.types";

import styles from "./index.module.scss";

type Props = {
  partnerships: PartnershipType[];
  handleCloseModal: () => void;
};

const MembershipPartners = ({ partnerships, handleCloseModal }: Props) => {
  return (
    <div
      className={[styles.membershipPartners, "no-scrollbar"].join(" ")}
      onClick={handleCloseModal}
    >
      <div className={styles.backgroundFilter} />
      {partnerships.map((partnership) => (
        <div key={partnership.id}>
          <Img
            src={partnership.picturePath}
            lazyLoad={false}
            alt={partnership.name}
            containerProps={{ className: styles.partner }}
          >
            <div className={styles.contactInformationContainer}>
              <MainButton
                href={partnership.websiteUrl}
                uiOnly
                className={styles.name}
              >
                {partnership.name}
              </MainButton>
              <address className={styles.contactInformation}>
                <a href={`tel:${partnership.phoneNumber}`}>
                  <PhoneIcon />
                </a>
                <a href={`mailto:${partnership.email}`}>
                  <AsperandIcon />
                </a>
                <a
                  href={`https://maps.google.com/?q=${partnership.location}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  referrerPolicy="no-referrer"
                >
                  <LocationIcon />
                </a>
                <a
                  href={`mailto:${partnership.email}`}
                  className={styles.external}
                  target="_blank"
                  rel="noreferrer"
                >
                  Contact <AsperandIcon />
                </a>
                <a
                  href={partnership.websiteUrl}
                  className={styles.external}
                  target="_blank"
                  rel="noreferrer"
                >
                  Discover <BookingIcon />
                </a>
              </address>
            </div>
          </Img>
          <div className={styles.description}>
            <p className={styles.location}>
              <span>Location</span>
              <span>{partnership.location}</span>
            </p>
            <p>{partnership.descriptionEn}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MembershipPartners;
